import { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { obtenerAsesor } from '../../actions/asesorias';

const MiAsesor = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Mi asesor',
            path: '/mi-asesor'
        }
    ];

    const dispatch = useDispatch();

    const { mi_asesor, historial_asesor } = useSelector(state => state.asesorias);

    const formatFecha = (fecha) => {
        if (!fecha) return 'Sin definir';
        return new Date(fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    useEffect(() => {
        dispatch(obtenerAsesor());
        dispatch(editarBreadcrumb(rutasBread));
    }, []);

    return (
        <div className="row">
            <div className="col-md-10 offset-md-1 pb-4">
                <h3 className="title-section my-5">Mi asesor</h3>

                {
                    !mi_asesor
                        ? (
                            <div className="alert alert-info">
                                <i className="fas fa-info-circle me-2"></i>
                                Aún no tienes un asesor asignado. Crea una asesoría para que se te asigne uno.
                            </div>
                        )
                        : (
                            <Fragment>
                                {/* Tarjeta principal del asesor */}
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div className="col-md-2 text-center mb-3 mb-md-0">
                                                <div
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        borderRadius: '50%',
                                                        background: '#0d6efd',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        margin: '0 auto'
                                                    }}
                                                >
                                                    <i className="fas fa-user-tie fa-2x text-white"></i>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3 mb-md-0">
                                                <h5 className="mb-1 fw-bold">{mi_asesor.nombre_completo}</h5>
                                                {
                                                    mi_asesor.email &&
                                                        <p className="mb-1 text-muted">
                                                            <i className="fas fa-envelope fa-sm me-2"></i>
                                                            <a href={`mailto:${mi_asesor.email}`} className="text-muted">{mi_asesor.email}</a>
                                                        </p>
                                                }
                                                {
                                                    mi_asesor.celular &&
                                                        <p className="mb-0 text-muted">
                                                            <i className="fas fa-phone fa-sm me-2"></i>
                                                            {mi_asesor.celular}{' '}
                                                            <a
                                                                href={`https://wa.me/${mi_asesor.celular.replace(/\D/g, '')}`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                <i className="fab fa-whatsapp text-success"></i>
                                                            </a>
                                                        </p>
                                                }
                                            </div>
                                            <div className="col-md-4 text-md-end">
                                                {
                                                    mi_asesor.email &&
                                                        <a href={`mailto:${mi_asesor.email}`} className="btn btn-outline-primary me-2">
                                                            <i className="fas fa-envelope fa-sm"></i> Contactar
                                                        </a>
                                                }
                                                {
                                                    mi_asesor.celular &&
                                                        <a
                                                            href={`https://wa.me/${mi_asesor.celular.replace(/\D/g, '')}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="btn btn-success"
                                                        >
                                                            <i className="fab fa-whatsapp fa-sm"></i> WhatsApp
                                                        </a>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Indicadores */}
                                <div className="row mb-4">
                                    <div className="col-md-4 mb-3">
                                        <div className="card text-center h-100">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                                <i className="fas fa-calendar-alt fa-2x text-primary mb-2"></i>
                                                <h6 className="text-muted mb-1" style={{ fontSize: '0.85rem' }}>Asesor desde</h6>
                                                <p className="mb-0 fw-bold">{formatFecha(historial_asesor?.desde)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <div className="card text-center h-100">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                                <i className="fas fa-clipboard-list fa-2x text-success mb-2"></i>
                                                <h6 className="text-muted mb-1" style={{ fontSize: '0.85rem' }}>Asesorías realizadas</h6>
                                                <p className="mb-0 fw-bold" style={{ fontSize: '1.5rem' }}>{historial_asesor?.total_asesorias ?? 0}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <div className="card text-center h-100">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                                <i className="fas fa-clock fa-2x text-warning mb-2"></i>
                                                <h6 className="text-muted mb-1" style={{ fontSize: '0.85rem' }}>Última asesoría</h6>
                                                <p className="mb-0 fw-bold">{formatFecha(historial_asesor?.ultima_asesoria?.fecha)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Detalle de la última asesoría */}
                                {
                                    historial_asesor?.ultima_asesoria &&
                                        <div className="card">
                                            <div className="card-header">
                                                <strong>Última asesoría</strong>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-6 mb-2">
                                                        <label className="fw-bold text-muted" style={{ fontSize: '0.8rem' }}>Motivo</label>
                                                        <p className="mb-0">{historial_asesor.ultima_asesoria.motivo || 'Sin definir'}</p>
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <label className="fw-bold text-muted" style={{ fontSize: '0.8rem' }}>Fecha</label>
                                                        <p className="mb-0">{formatFecha(historial_asesor.ultima_asesoria.fecha)}</p>
                                                    </div>
                                                    {
                                                        historial_asesor.ultima_asesoria.descripcion &&
                                                            <div className="col-md-12 mt-2">
                                                                <label className="fw-bold text-muted" style={{ fontSize: '0.8rem' }}>Descripción</label>
                                                                <p className="mb-0">{historial_asesor.ultima_asesoria.descripcion}</p>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                }
                            </Fragment>
                        )
                }
            </div>
        </div>
    )
}

export default MiAsesor;
